import React from 'react';

// Services
import { getTranslateByKey } from '@/main/services/utils';

// Components
import Button from '@/main/components/shared/button/button';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

// Styles
import * as S from './styles';

interface IModalDeletePredefinedSearch {
  open: boolean;
  predefinedSearchName: string | null;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  isLoading: boolean;
}

function ModalDeletePredefinedSearch({
  open,
  predefinedSearchName,
  handleModalCancel,
  handleModalConfirm,
  isLoading
}: IModalDeletePredefinedSearch) {
  
  if (!open) return null;

  const [before, after] = getTranslateByKey('information.userPredefinedSearchDelete')
  .split('{namePredefinedSearch}');

  return (
    <S.ModalOverlay>
      <S.BoxModal>
        <S.MessageText>
          {before}<b>{predefinedSearchName ?? ''}</b>{after}
        </S.MessageText>

        <S.ButtonsArea>
          <SecondaryButton type="button" onClick={handleModalCancel} disabled={isLoading}>
            {getTranslateByKey('information.no')}
          </SecondaryButton>

          <Button type="button" onClick={handleModalConfirm} isLoading={isLoading}>
            {getTranslateByKey('information.yes')}
          </Button>
        </S.ButtonsArea>
      </S.BoxModal>
    </S.ModalOverlay>
  );
}

export default ModalDeletePredefinedSearch;